<div class="dialog--title" cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" [cdkDragFreeDragPosition]="position" (cdkDragEnded)="onDragEnded($event)">
  <h6 mat-dialog-title class="grey1">{{ data.sysText.hideCase.hideCaseTitle | titlecase }}</h6>
  @if (isMobile$ | async) {
    <span class="spacer"></span>
    <button type="button" class="button-reset" (click)="cancel()" [attr.aria-label]="data.sysText.hideCase.cancel" [disabled]="isSubmitting$ | async">
      <mat-icon class="button-icon">close</mat-icon>
    </button>
  }
</div>

<mat-dialog-content>
  <p class="subtitle1 dialog-message">
    {{ data.sysText.hideCase.hideCaseMessage }}
  </p>
  <form [formGroup]="form">
    <app-select-field
      [control]="this.form.controls.hideReasonId"
      [icon]="'help_center'"
      [label]="data.sysText.hideCase.hideReasonCaption"
      [options]="hideReasonOptions"
      (emitSelectionChange)="hideReasonChangeHandler()"
    ></app-select-field>

    <app-text-area
      [control]="this.form.controls.comments"
      [label]="data.sysText.hideCase.hideCommentsCaption"
      [icon]="'comment'"
    ></app-text-area>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  @let isSubmitting = isSubmitting$ | async;
  @if (!(isMobile$ | async)) {
    <button
      mat-stroked-button
      class="button"
      color="accent"
      [disabled]="isSubmitting"
      (click)="cancel()">
      {{ data.sysText.hideCase.cancel }}
    </button>
  }
  <!-- save keeps focus while saving: showProgress lays the spinner over its label, disabledInteractive keeps it focusable, and the guard blocks clicks -->
  <button
    mat-stroked-button
    class="button"
    color="accent"
    [disabled]="isSubmitting"
    disabledInteractive
    [showProgress]="isSubmitting"
    [attr.aria-label]="isSubmitting ? data.sysText.hideCase.submitting_ariaLabel : null"
    (click)="!isSubmitting && hideCase()">
    {{ data.sysText.hideCase.hideCaseButtonCaption }}
    <mat-spinner progressIndicator diameter="30" color="accent"></mat-spinner>
  </button>
</mat-dialog-actions>
